import { api, getList } from "./api"; // ton axios ou fetch configuré
import type { Localisation } from "../types/localisation";

// Récupérer toutes les localisations
export async function getAllLocalisations(): Promise<Localisation[]> {
  return getList<Localisation>("/localisations/");
}

// Créer une localisation
export async function createLocalisation(localisation: Partial<Localisation>) {
  const { data } = await api.post("/localisations/", localisation);
  return data;
}

// Mettre à jour une localisation
export async function updateLocalisation(id: string, localisation: Partial<Localisation>) {
  const { data } = await api.put(`/localisations/${id}/`, localisation);
  return data;
}

// Supprimer une localisation
export async function deleteLocalisation(id: string) {
  await api.delete(`/localisations/${id}/`);
}
